import React from 'react';
import { LazyComponent } from '@fiverr-private/seller_pages_toolbox';
import { NotableClientsProps } from './types';

const lazyImport = () => import(/* webpackChunkName: 'NotableClients' */ './NotableClientsResolver');

export const LazyNotableClients: React.FC<NotableClientsProps> = (props) => (
    <LazyComponent moduleName="NotableClients" lazyImport={lazyImport} componentProps={props} />
);

export default LazyNotableClients;
